import script from "./MarkObservationAsRead.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkObservationAsRead.vue?vue&type=script&setup=true&lang=js"

import "./MarkObservationAsRead.vue?vue&type=style&index=0&id=01625368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01625368"]])

export default __exports__